import React from 'react';
import { SlidersHorizontal, Check } from 'lucide-react';
import './BookingRulesHeader.css';

/**
 * F1 — Header chrome for the Booking rules & availability card.
 *
 * Props:
 *   - isEditing
 *   - isDirty       — drives the amber "Unsaved" pill (only when editing)
 *   - isSaving
 *   - canSave       — gates the Save button (validation upstream)
 *   - onEdit, onCancel, onSave
 *
 * Layout: [icon tile] [title + subtitle]              [right cluster]
 *   - right cluster while editing: [Unsaved?] [Cancel] [✓ Save changes]
 *   - right cluster otherwise:     [Edit]
 */
const BookingRulesHeader = ({
  isEditing,
  isDirty,
  isSaving,
  canSave = true,
  onEdit,
  onCancel,
  onSave,
}) => {
  return (
    <header className="appointments-v3-rules-head">
      <div className="appointments-v3-rules-head-left">
        <span className="appointments-v3-rules-head-icon" aria-hidden="true">
          <SlidersHorizontal size={18} />
        </span>
        <div className="appointments-v3-rules-head-text">
          <h3 className="appointments-v3-rules-head-title">Booking rules &amp; availability</h3>
          <p className="appointments-v3-rules-head-subtitle">
            Applies to all services unless individually overridden.
          </p>
        </div>
      </div>

      <div className="appointments-v3-rules-head-actions">
        {isEditing ? (
          <>
            {isDirty && (
              <span
                className="appointments-v3-rules-unsaved-dot"
                role="status"
                aria-live="polite"
              >
                <span className="appointments-v3-rules-unsaved-bullet" aria-hidden="true" />
                Unsaved changes
              </span>
            )}
            <button
              type="button"
              className="appointments-v3-btn appointments-v3-btn-ghost"
              onClick={onCancel}
              disabled={isSaving}
            >
              Cancel
            </button>
            <button
              type="button"
              className="appointments-v3-btn appointments-v3-btn-primary"
              onClick={onSave}
              disabled={isSaving || !canSave}
            >
              <Check size={14} strokeWidth={2.5} aria-hidden="true" />
              <span>{isSaving ? 'Saving…' : 'Save changes'}</span>
            </button>
          </>
        ) : (
          <button
            type="button"
            className="appointments-v3-btn appointments-v3-btn-outline"
            onClick={onEdit}
          >
            Edit
          </button>
        )}
      </div>
    </header>
  );
};

export default BookingRulesHeader;
